import React from 'react';

import WirelineDepartments from './WirelineDepartments';

const Wireline = () => (
  <WirelineDepartments />
);

export default Wireline;
